export const Z_INDEX_DEFAULT = 1;
export const Z_INDEX_OVERLAY_LOW = 1070;
export const Z_INDEX_GLOBAL_TOOLBAR_HEADER = 1091;
export const Z_INDEX_OVERLAY_MEDIUM = 1111;
export const Z_INDEX_OVERLAY_HIGH = 1211;